// recoil/configState.js
import { atom } from "recoil";

const configState = atom({
  key: "configState",
  default: {
    initialized: false,
    org_identifier: "",
    colors: {
      primary_color: "",
      secondary_color: "",
      primary_dark_color: "",
      secondary_dark_color: "",
      primary_gradient_color: "",
      secondary_gradient_color: "",
    },
    meta: {
      title: "",
      description: "",
      org_name: "",
      tagline: "",
      documentation_url: "",
    },
    assets: {
      logoSrc: "",
      imageSrc: "",
      faviconSrc: "",
      co_branded: false,
    },
  },
});

export default configState;
